import React, { useState, useEffect, useContext } from 'react';

import Cookies from 'js-cookie';

import Dropdown from '../common/Dropdown'
import CampaignMenu from './CampaignMenu.js'

import { UserDataContext } from "../../App.js";
import { DISCORD_DEV_SERVER, DISCORD_DEV_CHANNEL } from '../../globals.js';
import updateCampaign from '../../helpers/updateCampaign.js';
import { sanitizeURL } from '../../helpers/sanitizeInput.js';

function DiscordMenu(props) {

    // ------------ parameters ---------------

    // ------ inherited state variables ------
    let [currentChar, setChar] = [ props.state[0], props.state[1] ];
    let [layout, setLayout] = [ props.state[3], props.state[4] ];
    const [userData, setUserData] = useContext(UserDataContext);
    const [isPlaying, setIsPlaying] = props.state[8];

    // -------- local state variables --------
    const [isTTS, setIsTTS] = useState(/Tabletop/i.test(navigator.userAgent));


    const campaignDiscordUrl = userData.campaignData?.discordURL;
    const isOwner = userData.campaignData?.campaignOwner === userData.uniqueUser
        || userData.dynamoData?.campaigns?.[userData.currentCampaign]?.role?.includes('admin');
    const showCampaignDiscord = !!userData.loggedIn && !!campaignDiscordUrl;
    const showAddUrl = !!userData.loggedIn && isOwner && !campaignDiscordUrl;

    let menuOptions = [
            ...(showCampaignDiscord ? ['Campaign Discord'] : []),
            ...(showAddUrl ? ['+Campaign URL'] : []),
            'Dev Discord'
          ];

    // -------------------------------------
    // EVENT HANDLER
    // -------------------------------------

    const handleMenu = async (selection) => {
        // Implement the various menu options here

                // ----------  CAMPAIGN DISCORD --------------
        if (menuOptions[selection] === 'Campaign Discord') {
            window.open(campaignDiscordUrl, '_blank').focus();
        }


        // ----------  ADD CAMPAIGN URL --------------
        else if (menuOptions[selection] === '+Campaign URL') {
            const urlRaw = prompt('Enter Discord URL for this campaign:');
            const url = sanitizeURL(urlRaw);
            if (!url) {
                if (urlRaw) alert('Invalid URL. Must be a valid https link to an allowed site.');
                return;
            }
            await updateCampaign(userData.currentCampaign, { discordURL: url });
            const newUserData = { ...userData };
            newUserData.campaignData = { ...userData.campaignData, discordURL: url };
            setUserData(newUserData);
        }

        // ----------  DEV DISCORD --------------
        else if (menuOptions[selection] === 'Dev Discord') {
            let URL = `https://discord.com/channels/${DISCORD_DEV_SERVER}/${DISCORD_DEV_CHANNEL}`
            window.open(URL, '_blank').focus();
        }


    } // end of HANDLE FUNCTION


    
    // ------------- useEffect ---------------
    /*
    useEffect( () => {

        async function DoSomething () {    
          
        }

        DoSomething();

    }, [] ); //useEffect
    */

        // ------------  Return JSX  ----------------
    
    return (
    
        <>
        <Dropdown
            trigger = {<button className="nav-settings-button">Discord</button>}
            menu = { menuOptions.map ( ( option, idx) => {

                if  ( option === 'Change Campaign' ) return <CampaignMenu key={idx} {...props} />

                else return <button id={'discord-option-' + idx } onClick={()=>handleMenu(idx)}>{option}</button>

                }
            )}
            divClass='menu-item sub-menu'
            menuClass="menu"
            onChildClose={props.onChildClose}
        />
        </>
    )

    };  // end of function

    export default DiscordMenu